import { render, staticRenderFns } from "./selectoptions.vue?vue&type=template&id=31228a50&"
import script from "./selectoptions.js?vue&type=script&lang=js&"
export * from "./selectoptions.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31228a50')) {
      api.createRecord('31228a50', component.options)
    } else {
      api.reload('31228a50', component.options)
    }
    module.hot.accept("./selectoptions.vue?vue&type=template&id=31228a50&", function () {
      api.rerender('31228a50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/inputs/selectoptions.vue"
export default component.exports